module.exports = __webpack_public_path__ + "img/tab-6.bb85eb86.png";